import React from 'react';

const IconDthree = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <title>d3-dot-js</title>
  <path fill="#f9a03c" d="M17.749 16c0-8.376-6.789-15.167-15.167-15.167h-2.583v6.667h2.584c4.695 0 8.5 3.805 8.5 8.5s-3.805 8.5-8.5 8.5h-2.584v6.667h2.584c8.375 0 15.165-6.791 15.165-15.167zM32 10.084c0-5.109-4.143-9.251-9.251-9.251h-10.667c2.627 1.663 4.743 3.913 6.201 6.574l0.047 0.093h4.419c1.425 0 2.584 1.157 2.584 2.584s-1.159 2.584-2.584 2.584h-2.584c0.417 2.203 0.417 4.464 0 6.667h2.584c1.424 0 2.584 1.156 2.584 2.584s-1.159 2.584-2.584 2.584h-4.419c-1.505 2.754-3.621 5.003-6.175 6.623l-0.073 0.043h10.667c2.161 0 4.255-0.757 5.917-2.14 3.924-3.267 4.461-9.099 1.193-13.027 1.331-1.592 2.139-3.661 2.14-5.919v-0z"></path>
  </svg>
);

export default IconDthree;